import { useTranslation } from "react-i18next";
import { KaTeXPreview } from "./KaTeXPreview";
import { FormField, FormLabel } from "@acdc2/ui/components/access-form";

type Props = {
  latex: string;
};

export function ExpressionPreviewFormField({ latex }: Props) {
  const { t } = useTranslation();

  return (
    <FormField name="expressionPreview">
      <FormLabel>{t("ExpressionPreviewFormField.label")}</FormLabel>
      <KaTeXPreview latexExpression={latex} />
    </FormField>
  );
}
